import { useMutation,useQuery,useQueryClient} from "react-query";
import {addTeam,
  getAllPersonByTenantId,addStrategy,
  editPerson,deleteTeam,deletePerson,
  editPersonStaff,deleteInvitedPerson,
  getTeamDetail,
  editTeam,
  deleteStrategy,
  deleteMission,
  getAllStrategies,
  getAllStrategicBAU,
  getAllTenantMission,
  getMaxObjective,
  editTenantMission,
  addTenantMission,
  getMaxbau,
  getMaxkr,
  editStrategy
} from '../Api/index';
import {deleteMeeting} from '../../Meeting/Api/Index';

     const useAddTeam=()=>{
      const queryClient=useQueryClient()
      return useMutation({
    mutationFn: (userData:any) =>addTeam(userData),
    onSuccess: (data:any) => {
      queryClient.invalidateQueries('getAllTeams')
    },
  });
     }
 
     const useGetAllPersonByTenantId=(tenantId:string|null)=>{
     return useQuery(['getAllPersonByTenantId',tenantId],getAllPersonByTenantId,{
      enabled:!!tenantId,
      cacheTime:Infinity,
      refetchOnWindowFocus:false,
      onSuccess:(data:any)=>{
      },
      select:(data:any)=>{
        let rawData=data?.data?.data;
        return rawData
      }
     })
     }

     const useGetAllStrategies=(tenantId:string|null,periodId:string|null)=>{
      return useQuery(['getAllStrategies',tenantId,periodId],getAllStrategies,{
       enabled:!!tenantId,
       cacheTime:Infinity,
       refetchOnWindowFocus:false,
       onSuccess:(data:any)=>{
       },
       select:(data:any)=>{
         let rawData=data?.data?.data;
         return rawData
       }
      })
      }

      const useGetMaxObjective=(tenantId:string|null,periodId:string|null)=>{
        return useQuery(['getMaxObjective',tenantId,periodId],getMaxObjective,{
         enabled:!!tenantId,
         cacheTime:Infinity,
         refetchOnWindowFocus:false,
         onSuccess:(data:any)=>{
         },
         select:(data:any)=>{
           let rawData=data?.data?.data;
           return rawData
         }
        })
        }


        const useGetMaxkr=(tenantId:string|null,periodId:string|null)=>{
          return useQuery(['getMaxkr',tenantId,periodId],getMaxkr,{
           enabled:!!tenantId,
           cacheTime:Infinity,
           refetchOnWindowFocus:false,
           onSuccess:(data:any)=>{
           },
           select:(data:any)=>{
             let rawData=data?.data?.data;
             return rawData
           }
          })
          }

          const useGetMaxbau=(tenantId:string|null,periodId:string|null)=>{
            return useQuery(['getMaxbau',tenantId,periodId],getMaxbau,{
             enabled:!!tenantId,
             cacheTime:Infinity,
             refetchOnWindowFocus:false,
             onSuccess:(data:any)=>{
             },
             select:(data:any)=>{
               let rawData=data?.data?.data;
               return rawData
             }
            })
            }

      const useGetAllStrategicBAUByTenantId=(tenantId:string|null,periodId:string|null)=>{
        return useQuery(['getAllStrategicBAU',tenantId,periodId],getAllStrategicBAU,{
         enabled:!!tenantId,
         cacheTime:Infinity,
         refetchOnWindowFocus:false,
         onSuccess:(data:any)=>{
         },
         select:(data:any)=>{
           let rawData=data?.data?.data;
           return rawData
         }
        })
        }

      const UseGetAllTenantMission=(tenantId:string|null,periodId:string|null)=>{
        return useQuery(['getAllTenantMission',tenantId,periodId],getAllTenantMission,{
         enabled:!!tenantId,
         cacheTime:Infinity,
         refetchOnWindowFocus:false,
         onSuccess:(data:any)=>{
          let rawData=data?.data?.data;
           return rawData
         },
         select:(data)=>{
          let rawdata=data?.data;
           return rawdata
      }
        })
        }

     const useAddStrategy=()=>{
      const queryClient=useQueryClient()
      return useMutation({
    mutationFn: (userData:any) =>
      addStrategy(userData),
    onSuccess: (data:any) => {
      queryClient.invalidateQueries('getAllStrategies')
    },
  });
}


const useAddTenantMission=()=>{
  const queryClient=useQueryClient()
  return useMutation({
mutationFn: (userData:any) =>
  addTenantMission(userData),
onSuccess: (data:any) => {
  queryClient.invalidateQueries('getAllTenantMission')
},
});
}
const useEditTenantMission=()=>{
  const queryClient=useQueryClient()
  return useMutation({
mutationFn: (userData:any) =>
  editTenantMission(userData),
onSuccess: (data:any) => {
  queryClient.invalidateQueries('getAllTenantMission')
},
});
}

const useEditStrategy=()=>{
  const queryClient=useQueryClient()
  return useMutation({
mutationFn: (userData:any) =>
  editStrategy(userData),
onSuccess: (data:any) => {
  queryClient.invalidateQueries('getAllStrategies')
},
});
}


     const useGetPersonDetails=(perId:string|null, tenantId:string)=>{
      // console.log(perId)
      return useQuery(['GetPersonDetails',perId,tenantId],editPerson,{
       enabled:!!perId,
       refetchOnWindowFocus:false,
       cacheTime:Infinity,
       onError:(err:any)=>{
      //  console.log(err)
       }
       ,
      select:(data)=>{
        let rawData=data?.data.data;
        return rawData
      }
      })
     }

      const useDeleteTeam=()=>{
        const queryClient=useQueryClient()
          return useMutation({
        mutationFn: (data:any) =>deleteTeam(data),
        onSuccess: (data) => {
            queryClient.invalidateQueries('getAllTeams')
        },
      });
    }


    const useDeleteMeeting=()=>{
      const queryClient=useQueryClient()
        return useMutation({
      mutationFn: (data:any) =>deleteMeeting(data),
      onSuccess: (data) => {
          queryClient.invalidateQueries('getAllMeetingByIds')
      },
    });
  }

  const useDeleteMission=()=>{
    const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (userData:any) =>deleteMission(userData),
  onSuccess: (data:any) => {
    queryClient.invalidateQueries('getAllTenantMission')
  },
   });
   }

   const useDeleteStrategy=()=>{
    const queryClient=useQueryClient()
    return useMutation({
  mutationFn: (userData:any) =>deleteStrategy(userData),
  onSuccess: (data:any) => {
    queryClient.invalidateQueries('getAllStrategies')
  },
   });
   }

    const useDeletePerson=()=>{
      const queryClient=useQueryClient()
      return useMutation({
    mutationFn: (userData:any) =>deletePerson(userData),
    onSuccess: (data:any) => {
      queryClient.invalidateQueries('getAllPersonByTenantId')
    },
     });
     }
 

    const useDeleteInvitedPerson=()=>{
      const queryClient=useQueryClient()
      return useMutation({
    mutationFn: (userData:any) =>deleteInvitedPerson(userData),
    onSuccess: (data:any) => {
      queryClient.invalidateQueries('getAllPersonByTenantId')
    },
  });
     }


    const useEditPersonStaff=(editSuccess:any)=>{
      const queryClient=useQueryClient()
      return useMutation({
    mutationFn: (userData:any) =>editPersonStaff(userData),
    onSuccess: (data:any) => {
      queryClient.invalidateQueries('getAllPersonByTenantId')
    },
  });
     }

     const useEditTeam=()=>{
      const queryClient=useQueryClient()
      return useMutation({
    mutationFn: (userData:any) =>editTeam(userData),
    onSuccess: (data:any) => {
      queryClient.invalidateQueries('getAllTeams')
    },
  });
     }
  
     const useGetTeamDetail=(teamId:string|null)=>{
       return useQuery(['GetTeamDetails',teamId],getTeamDetail,{
        enabled:!!teamId,
        refetchOnWindowFocus:false,
        cacheTime:Infinity,
        onError:(err:any)=>{
        // console.log(err)
        }
        ,
       select:(data)=>{
         let rawData=data?.data.data;
         return rawData
       //  console.log(data)
       }
 
       })
     }


     export{
       useAddTeam,
       useGetMaxObjective,
       useGetAllStrategies,
       useGetAllPersonByTenantId,
       useAddStrategy,
       useGetPersonDetails,
       useDeleteTeam,
       useDeleteMeeting,
       useDeletePerson,
       useDeleteMission,
       useEditPersonStaff,
       useDeleteInvitedPerson,
       useGetTeamDetail,
       useEditTeam,
       useDeleteStrategy,
       useGetAllStrategicBAUByTenantId,
       useEditStrategy,
       useEditTenantMission,
       UseGetAllTenantMission,
       useAddTenantMission,
       useGetMaxbau,
       useGetMaxkr
     }